// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"PopularDestinations_gridContainer__J_BHz","inlineContainer":"PopularDestinations_inlineContainer__hCbcW","linkContainer":"PopularDestinations_linkContainer__Sw7_U"};